export default {
  Link: ({ item }) => (
    <a href={item.url}>
      {item.title}
    </a>
  ),
  Description: ({ item }) => (item.description ? <p>{item.description}</p> : null),
}
